<template>
  <div class="modal-booking-data-container">
    <sweet-modal ref="dateModal" overlay-theme="dark">
      <div class="modal-title">일정 설정</div>
      <div v-if="item" class="content">
        <div class="grid-item">
          <div class="grid-title">선택 날짜</div>
          <div>{{ item.date_str }}</div>
        </div>
        <div class="grid-item">
          <div class="grid-title">예약 가능 여부</div>
          <lp-radio :val.sync="item.possible_resv"
                    value_name="value"
                    label_name="label"
                    :data="[{label: '가능', value: true}, {label: '예약불가', value: false}]"></lp-radio>
        </div>
        <div class="grid-item">
          <div class="grid-title">가격</div>
          <div>
            <div class="flex-align" style="margin-bottom:12px">
              <input class="input-border" type="number"
                placeholder="0" min="0" @keyup="e => item.price = Number(e.target.value)" v-model="item.price">
              <div class="size-14" style="margin-left:4px">원</div>
            </div>
            <div class="flex-align" style="gap:0 12px">
              <select class="input-border" v-model="item.discount_type">
                <option :value="-1">할인없음</option>
                <option :value="0">할인율</option>
                <option :value="1">금액할인</option>
              </select>
              <div class="flex-align">
                <div v-if="item.discount_type===0" class="flex-align">
                  <input class="input-border" type="number"
                    placeholder="0" min="0" @keyup="e => item.discount_rate = Number(e.target.value)" v-model="item.discount_rate">
                  <div class="size-14" style="margin-left:4px">%</div>
                </div>
                <div v-else-if="item.discount_type===1" class="flex-align">
                  <input class="input-border" type="number"
                    placeholder="0" min="0" @keyup="e => item.discount_price = Number(e.target.value)" v-model="item.discount_price">
                  <div class="size-14" style="margin-left:4px">원</div>
                </div>
              </div>
            </div>
            <div class="size-14" style="margin-top:12px"
                 v-if="item.discount_type>-1">할인 후 가격<b style="margin-left:8px">{{ calcDiscount|currency }}</b></div>
            <template v-if="item.org">
              <div class="divider"></div>
              <div class="flex-align unselect"
                   @click="clickRefresh">
                <img :src="svgSrc('refresh')">
                <div class="size-13" style="color:#787878">기본 요일 가격으로 재설정</div>
              </div>
            </template>
          </div>
        </div>
        <div class="grid-item" v-if="item.ordered_count && item.ordered_count>0">
          <div class="grid-title">예약내역</div>
          <div>{{ item.ordered_count }}건</div>
        </div>
        <div class="grid-item">
          <div class="grid-title">전체 수량</div>
          <div style="display: grid;gap:10px 0">
            <div class="flex-align" style="width:154px;gap:0 16px;padding-bottom:10px">
              <input type="number" class="input-border"
                     v-model="item.stock" :disabled="isInfinite">
              <lp-check-bool label="무한대" :checkedVal.sync="isInfinite"></lp-check-bool>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-group-justify-end" style="padding-top:12px">
        <button class="button is-light" @click="clickCancel">취소</button>
        <button class="button is-primary" @click="clickAccept">저장</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import LpRadio from "../../../module/common/LpRadio";
  import LpCheckBool from "../../../module/common/LpCheckBool";

  export default {
    name: 'ModalBookingDate',
    components: {
      LpCheckBool,
      LpRadio,
      SweetModal
    },
    props: {
      prod: {
        type: Object
      },
      item: {
        type: Object
      }
    },
    methods: {
      open() {
        // init
        this.isInfinite = this.item.stock_type === 1;

        this.$refs.dateModal.open();
      },
      clickRefresh() {
        Object.keys(this.item.org).forEach(key => {
          this.item[key] = this.item.org[key];
        });
      },
      clickCancel() {
        this.$refs.dateModal.close();
      },
      clickAccept() {
        this.item.is_discount = this.item.discount_type > -1;
        if(this.item.discount_type === 0) {
          this.item.sale_price = this.item.price - (this.item.price * (this.item.discount_rate / 100))
        } else if(this.item.discount_type === 1) {
          this.item.sale_price = this.item.price - this.item.discount_price;
        } else {
          this.item.sale_price = this.item.price;
        }

        this.$axios.post(this.getUrl(`booking/product/${this.prod.id}/date_price`), this.item).then(res=> {
          if(res.status === 200) {
            this.$emit('updatePrice', res.data.price);
            this.$emit('accept', this.cloneItem(this.item));
            this.$refs.dateModal.close();
            this.toastStatus('일정이 저장되었습니다.');
          }
        }).catch(()=> {
          this.toastStatus('저장에 실패했습니다.');
        })
      }
    },
    computed: {
      calcDiscount() {
        let price = 0;
        if(this.item.discount_type === 0) {
          price = this.item.price - (this.item.price * (this.item.discount_rate / 100))
        } else {
          price = this.item.price - this.item.discount_price;
        }
        return price;
      }
    },
    data() {
      return {
        isInfinite: false
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .modal-booking-data-container
    color #363636

  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .input-border
    border 1px solid #cccccc
    border-radius 4px
    padding 7px
    width 100%
    flex 1
  input[type=number]
    color #363636

  .grid-item
    display grid
    grid-template-columns 120px 1fr
    column-gap 12px
    padding-bottom 28px
    border-bottom 1px solid #eeeeee
    margin-bottom 28px
  .grid-item:last-child
    margin-bottom 0
    border-bottom 0

  .divider
    width 100%
    height 1px
    background-color #eeeeee
    margin 12px 0

  .grid-title
    font-size 14px
</style>

<style lang="stylus">
  .sweet-modal-overlay
    -webkit-perspective initial

  .modal-booking-data-container
    .sweet-modal.is-alert
      width 544px
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px
</style>
